import * as client from "@infrastructure/ClientConsumer";
import {
    SUPPORTED_VALUES,
    TimelineData,
    TimelineEventResponse,
} from "./Timeline/Types";
import { generatePath } from "react-router-dom";
import { FunFactType } from "./FunFacts/FunFactsSection";

const routes = {
    GET_TIMELINE: "/posts/:postId/game-timeline",
    GET_GAME_TIMELINE: "/game-timeline/:id",
    GET_BET_STATISTICS: "/posts/:postId/bet-statistics",
};
export type WatchAppApiStatusType = {
    directComparisonStatus: "not_available" | "available" | "disabled";
    hasGameUpdateIssues: boolean;
    lineupStatus: "not_available" | "available" | "disabled";
    timelineStatus:
        | "not_available"
        | "available"
        | "delayed"
        | "interrupted"
        | "disabled";
};

type TimelineApiResponseType = {
    funFacts: FunFactType[];
    timeline: TimelineData;
    watchAppApiStatus: WatchAppApiStatusType | undefined;
};

export async function getPostTimeline(
    postId: string,
): Promise<TimelineApiResponseType | undefined> {
    return client
        .getData(routes.GET_TIMELINE.replace(":postId", postId))
        .then((res) => {
            if (!res.data.result.sportEvent) {
                return undefined;
            }
            return {
                timeline: {
                    sportEvent: res.data.result["sportEvent"],
                    sportEventStatus: res.data.result["sportEventStatus"],
                    timeline: res.data.result.timeline
                        ? filterUnsupportedEvents(
                              res.data.result.timeline,
                          ).reverse()
                        : [],
                },
                funFacts: res.data.funFacts,
                watchAppApiStatus: res.data.watchAppApiStatus,
            };
        });
}

function filterUnsupportedEvents(timeline: TimelineEventResponse[]) {
    const supportedValues = Object.values(SUPPORTED_VALUES);
    return timeline.filter((item) => supportedValues.includes(item.type));
}

export async function getGameTimelineDetails(gameId: string) {
    return client
        .getData(
            generatePath(routes.GET_GAME_TIMELINE, {
                id: gameId,
            }),
            {},
        )
        .then((res) => {
            if (!res.data.sport_event) {
                return undefined;
            }
            return {
                sportEvent: res.data["sportEvent"],
                sportEventStatus: res.data["sportEventStatus"],
                timeline: res.data.timeline
                    ? filterUnsupportedEvents(res.data.timeline).reverse()
                    : [],
            };
        });
}

export function getBetStatistics(postId: string) {
    return client
        .getData(
            generatePath(routes.GET_BET_STATISTICS, {
                postId: postId,
            }),
        )
        .then((res) => res.data);
}

export const WATCH_APP_GAME_URL = `${process.env.REACT_APP_WATCHAPP_BASE_URL}/ul/spieluebersicht/:gameId/`;
